import { AWSCommon, AWSCommonAttributes } from './AWSCommon'

export class LambdaFunction extends AWSCommon {
  constructor({ ...ob }: AWSCommonAttributes) {
    super(ob)
    /** not required if arn is correct, retained to show can be used if some arns are deviant */
    this.type = 'LambdaFunction'
  }
}

export class DynamoDBTable extends AWSCommon {
  constructor({ ...ob }: AWSCommonAttributes) {
    super(ob)
  }
}
